import { z } from "zod";

export const coverageRequestSchema = z.object({
  id: z.number(),
  clientId: z.number(),
  clientName: z.string().nullish(),
  siteId: z.number(),
  siteName: z.string().nullish(),
  siteTimeZone: z.string().nullish(),
  requestedStartUtc: z.string(),
  requestedEndUtc: z.string(),
  startOffsetMinutes: z.number().nullish(),
  endOffsetMinutes: z.number().nullish(),
  guardsNeeded: z.number().nullish(),
  notes: z.string().nullish(),
  status: z.string(),
  decisionReason: z.string().nullish(),
  decidedOnUtc: z.string().nullish(),
  createdShiftId: z.number().nullish(),
  isLapsed: z.boolean().nullish(),
  createdOn: z.string().nullish(),
  requestedByUserId: z.number().nullish(),
  requestedByName: z.string().nullish(),
  requestedByEmail: z.string().nullish(),
  requestedByPhone: z.string().nullish(),
  decidedByName: z.string().nullish(),
  shiftNumberOfGuards: z.number().nullish(),
  shiftAssignedGuardsCount: z.number().nullish(),
  shiftAcceptedGuardsCount: z.number().nullish(),
});

export const coverageRequestPageSchema = z.object({
  items: z.array(coverageRequestSchema),
  totalCount: z.number(),
  pageNumber: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
});

export type CoverageRequestPage = z.infer<typeof coverageRequestPageSchema>;

export type CoverageRequestSortBy =
  | "RequestedStart"
  | "CreatedOn"
  | "GuardsNeeded"
  | "Status";

export interface CoverageRequestQuery {
  status?: CoverageRequestStatus;
  clientId?: number;
  siteId?: number;
  windowFrom?: string;
  windowTo?: string;
  submittedFrom?: string;
  submittedTo?: string;
  isLapsed?: boolean;
  sortBy?: CoverageRequestSortBy;
  sortDescending?: boolean;
  pageNumber?: number;
  pageSize?: number;
}

export const coverageRequestListSchema = z.array(coverageRequestSchema);

export type CoverageRequest = z.infer<typeof coverageRequestSchema>;

export const COVERAGE_REQUEST_STATUS = {
  Submitted: "Submitted",
  Accepted: "Accepted",
  Declined: "Declined",
  Cancelled: "Cancelled",
} as const;

export type CoverageRequestStatus =
  (typeof COVERAGE_REQUEST_STATUS)[keyof typeof COVERAGE_REQUEST_STATUS];

export function isAwaitingDecision(request: CoverageRequest): boolean {
  return request.status === COVERAGE_REQUEST_STATUS.Submitted && !request.isLapsed;
}

export function isAcceptedWithoutShift(request: CoverageRequest): boolean {
  return request.status === COVERAGE_REQUEST_STATUS.Accepted && !request.createdShiftId;
}
